import { getMessages } from '../../../store/constants';

export const TIME_LABEL = getMessages().getText('common.time');
export const TIME_START = getMessages().getText('timetracker.start');
export const TIME_STOP = getMessages().getText('timetracker.stop');
